module.exports = __webpack_public_path__ + "static/media/slide-show.e7636c73.svg";